export { AirHelpScoreAdapter as AirHelpScoreWrapper } from "./AirHelpScoreWrapper";
export type {
  AirHelpScoreWrapperProps,
  AirportRankingTemplateProps,
  AirlineRankingTemplateProps,
  AirHelpScoreWrapperTemplateProps,
  AirHelpScoreTemplateContent,
} from "./AirHelpScoreWrapper.d";
